import { fetchEB } from '@eventbrite/legacy-infra.http';
import { LocationRequest } from '../types';

export const getLocationFromRequest = (): Promise<LocationRequest> =>
    fetchEB('/home/api/geo/place_from_request/').then((res) => res.json());
